export default "<p>\r\n  Why purchase an Add On? \r\n</p>\r\n";